var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-bar-component"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"index-bar"},[_c('div',{staticClass:"index-items"},_vm._l((_vm.items),function(item){return _c('ct-index-item',{key:item.id,attrs:{"item":item}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }